<template>
  <a-form-item name="channel" :label="label">
    <a-tooltip placement="bottom">
      <template #title  v-if="toTicketsFilter && !isDropdownOpen">
        Hay {{totalTickets}} {{totalTickets === 1 ? 'ticket' : 'tickets'}} en total.
      </template>
      <a-select
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        v-model:value="selected"
        class="select"
        data-test="CHANNELS_PICKER"
        @dropdownVisibleChange="handleDropdownVisibleChange"
      >
        <a-select-option :value="defaultBehavior ? '' : 0">
          Todos los canales 
          <span v-if="toTicketsFilter">({{ totalTickets }})</span>
        </a-select-option>
        <a-select-option v-for="item in items" :key="item.id">
          <span>
            <icon-channel :type="item.id" :src="item.icon" :width="20" />
            {{ item.name }} 
            <span v-if="toTicketsFilter">({{ channelCounts[item.id] || 0 }})</span>
          </span>
        </a-select-option>
      </a-select>
    </a-tooltip>
  </a-form-item>
</template>

<script>
import IconChannel from "@/app/shared/components/icons/IconChannel.vue";
import { ChannelType, ChannelVoice } from "@/app/shared/utils/enums";
import { fetchAllChannels } from "@/app/ticketsManager/services";

const channels = [
  { id: ChannelType.Whatsapp, name: "WhatsApp", icon: "whatsapp.png" },
  { id: ChannelType.Messenger, name: "Messenger", icon: "messenger.png" },
  { id: ChannelType.Inbound, name: "Web Chat", icon: "inbound.png" },
  // Hidden PoC
  // { id: ChannelType.Sms, name: "SMS", icon: "sms.png" },
  { id: ChannelType.Voice, name: "Voz", icon: "sms.png" },
  { id: ChannelType.Instagram, name: "Instagram", icon: "instagram.png" },
];

export default {
  components: {
    IconChannel,
  },
  props: {
    value: {
      required: true,
      type: [Number, String],
    },
    label: {
      required: false,
      type: String,
      default: "",
    },
    defaultBehavior: {
      type: Boolean,
      default: false,
    },
    toSequence: {
      type: Boolean,
      default: false,
    },
    toTicketsFilter: {
      type: Boolean,
      default: false,
    },
    isChatbot:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      items: [],
      isDropdownOpen: false,
    };
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("update:value", value);
      },
    },
    tickets() {
      return this.$store?.getters?.["getWorkspaceTickets"] || [];
    },
    totalTickets() {
      // return Array.isArray(this.tickets) ? this.tickets.length : 0;
      return Object.values(this.channelCounts)
        .reduce((acc, val) => acc + Number(val), 0);
    },
    channelCounts() {
      const channelsTickets = this.$store.getters?.["getWorkspaceChannelsTickets"] || []
      const counts = {};
      for (const t of channelsTickets || []) {
        const id = t?.id;
        if (id === undefined || id === null) continue;
        counts[id] = t.total;
      }
      console.log('counts: ', counts)
      return counts;
    },
    // channelCounts() {
    //   const counts = {};
    //   for (const t of this.tickets || []) {
    //     const id = t?.channel?.id;
    //     if (id === undefined || id === null) continue;
    //     counts[id] = (counts[id] || 0) + 1;
    //   }
    //   return counts;
    // },
  },
  async mounted() {
    const response = await fetchAllChannels({ toSequence: this.toSequence });
    console.log(response,"excludedChannels");
    this.items = response?.filter((channel) => channel.name !== "IVR" && this.channelsForChatbot(channel));
  },
  methods: {
    handleDropdownVisibleChange(open) {
      this.isDropdownOpen = open;
    },
    channelsForChatbot(channel){
      if (this.isChatbot){
        const excludedChannels = [
          ChannelType.Email,
          ChannelType.Sms,
          ...ChannelVoice
        ];

        console.log(excludedChannels,"excludedChannels");
        return !excludedChannels.includes(channel.id);
      }

      return true
    }
  },
};
</script>

<style lang="sass" scoped>
.select
  width: 100%
</style>
